import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MultiSelectChangeEvent, MultiSelectModule } from 'primeng/multiselect';
import { NrMultiselectAieaPropDirective } from './directives/nr-multiselect-aiea-prop.directive';
import { INRSelect, INRSelectChange } from '../../interfaces/nr-select.interface';
import { CatService } from '@modules/cat/services/cat.service';

@Component({
  selector: 'nr-multiselect',
  templateUrl: './nr-multiselect.component.html',
  standalone: true,
  imports: [
    MultiSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NrMultiselectAieaPropDirective,
  ],
})
export class NRMultiselectComponent implements OnInit {
  @Input() set config(config: INRSelect) {
    this.configData = config;
    this.setDefaultValue();
  }
  @Input() hasError = false;
  @Output() selectedDataEvent = new EventEmitter<INRSelectChange[]>();

  selectAll = false;

  defaultConfig: INRSelect = {
    placeholder: 'Select',
    data: [],
    selectedItems: [],
    optionLabel: 'name',
    filter: true,
    showToggleAll: true,
    selectionMode: 'checkbox',
    isRequiredField: false,
    resetFilterOnHide: true,
    group: false,
    optionGroupLabel: 'name',
    optionGroupChildren: 'routes',
  };
  configData!: INRSelect;
  filter = false;
  showToggleAll = true;
  isRequiredField = false;
  resetFilterOnHide = true;
  isCatPlaybackActive = false;
  multiSelectFormControl = new FormControl('');
  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly catService: CatService,
  ) {}

  ngOnInit() {
    this.catService.isCatPlaybackActive$.subscribe((state) => {
      this.isCatPlaybackActive = state;
      this.isCatPlaybackActive
        ? this.multiSelectFormControl.disable()
        : this.multiSelectFormControl.enable();
    });
  }

  resetFormControl(): void {
    this.multiSelectFormControl.reset();
    this.selectAll = false;
  }

  validateFormControl(): void {
    this.multiSelectFormControl.markAsDirty({
      onlySelf: true,
    });
  }

  onSelectAllChange(evt) {
    let prepSelectedItems: INRSelectChange[] = [];
    const optionValue: string = this.configData.optionValue as string;
    if (evt.checked) {
      if (this.configData.optionValue) {
        this.configData.data.forEach((item) => {
          prepSelectedItems.push(item[optionValue]);
        });
      } else {
        prepSelectedItems = this.configData.data;
      }
    }
    this.configData.selectedItems = prepSelectedItems;
    this.selectAll = evt.checked;
    this.selectedDataEvent.emit(this.configData.selectedItems);
  }

  resetSelectAll(value: boolean) {
    this.selectAll = value;
  }

  onChangeHandler(evt: MultiSelectChangeEvent) {
    const selectedValues = evt.value ?? [];
    this.selectAll = selectedValues.length === (this.configData?.data?.length ?? 0);
    this.selectedDataEvent.emit(selectedValues);
  }

  private setDefaultValue() {
    this.filter = (this.configData.filter ?? this.defaultConfig.filter) as boolean;
    this.showToggleAll = (this.configData.showToggleAll ??
      this.defaultConfig.showToggleAll) as boolean;
    this.configData.selectionMode =
      this.configData.selectionMode ?? this.defaultConfig.selectionMode;
    this.configData.label = this.configData.label ?? this.defaultConfig.label;
    this.configData.placeholder = this.configData.placeholder ?? this.defaultConfig.placeholder;
    this.configData.selectedItems =
      this.configData.selectedItems ?? this.defaultConfig.selectedItems;
    this.configData.optionLabel = this.configData.optionLabel ?? this.defaultConfig.optionLabel;
    this.isRequiredField = (this.configData.isRequiredField ??
      this.defaultConfig.isRequiredField) as boolean;
    this.multiSelectFormControl = this.configData.frmControl ?? this.multiSelectFormControl;
    this.resetFilterOnHide = (this.configData.resetFilterOnHide ??
      this.defaultConfig.resetFilterOnHide) as boolean;
    this.cd.detectChanges();
  }
}
